import { Injectable, Injector, Type } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { EditableEsvrComponent } from '@features/batches/batch-detail/editable-esvr/editable-esvr.component';

@Injectable({ providedIn: 'root' })
export class SidenavService {
  private sidenav: MatSidenav;
  // tslint:disable-next-line: no-any
  component: Type<any>;
  injector: Injector;

  public setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  // tslint:disable-next-line: no-any
  public open(component: Type<any>, injector: Injector) {
    this.component = component;
    this.injector = injector;
    return this.sidenav.open();
  }

  public close() {
    return this.sidenav.close();
  }

  public toggle(): void {
    this.sidenav.toggle();
  }
  public sideNavOnClose() {
    if (this.component === EditableEsvrComponent) {
      return this.sidenav._closedStream;
    }
  }
}
